import { B2BPlanType, B2CPlanType } from "@/pages/billing/pricing-data";
import { PaymentInterval } from "@/types/subscription.types";
import { create } from "zustand";

export type PaymentIntervalWithoutCustom = Omit<PaymentInterval, "CUSTOM">;

export type PaymentIntervalWithoutCustom2 =
  | PaymentInterval.ANNUAL
  | PaymentInterval.QUARTERLY
  | PaymentInterval.SEMI_YEARLY
  | PaymentInterval.MONTHLY;

export interface DowngradeConfig {
  subscriptionId: string;
  planId: string;
  planType: B2BPlanType | B2CPlanType | "SEED_LIST";
  currentInterval: PaymentIntervalWithoutCustom;
  option: "plan" | "cycle" | "config";
  count: number;
  targetInterval?: PaymentIntervalWithoutCustom;
  targetPlanType?: B2BPlanType | B2CPlanType;
  // Seed list specific configuration
  targetSeedAccounts?: number | null;
  targetSenderProfiles?: number | null;
  currentSeedAccounts?: number;
  currentSenderProfiles?: number;
}

interface DowngradeStore {
  downgradeConfig: DowngradeConfig | null;
  setDowngradeConfig: (downgradeConfig: DowngradeConfig) => void;
}

export const useDowngradeStore = create<DowngradeStore>((set) => ({
  downgradeConfig: null,
  setDowngradeConfig: (downgradeConfig: DowngradeConfig) =>
    set({ downgradeConfig }),
}));
